<template>
    <div
        id="filter"
        class="flex flex-row flex-no-wrap sm:justify-center bg-white uppercase overflow-x-auto overflow-y-hidden scrolling-touch text-dark-blue-500 text-base font-semibold whitespace-no-wrap p-2 pb-0"
        data-cy="newsFilter"
    >
        <router-link
            v-for="type in types"
            :to="getPath(type)"
            :key="type.id"
            :ref="type.display"
            data-cy="typeFilter"
            class="pl-2 pr-2 border-selected cursor-pointer hover:text-red-600"
            v-bind:class="{ 'border-b-4': isSelected(type) }">
            <p>{{ type.display }}</p>
        </router-link>
    </div>
</template>

<script>
export default {
    name: "NewsFilter",
    data() {
        return {
            types: [
        {
          id: "",
          display: "News Releases",
        },
      ],
        };
    },
    props: ["isModalShown", "selectedFilter"],
    methods: {
        /**
         * @returns true|false based on property `selectedFilter`
         */
        isSelected: function(item) {
            return item.id === this.selectedFilter;
        },
        /**
         * @returns string path based on `types` iteration
         */
        getPath: function(item) {
            let path = "/news";

            if (item.id !== null) {
                path += `/${item.id}`;
            }

            return path;
        }
    },
    computed: {
        /**
         * Updates Tailwind CSS class based on property `isModalShown`
         */
        isHidden: function() {
            if (this.isModalShown) {
                return "hidden";
            } else {
                return "";
            }
        },
    },
};
</script>

<style scoped>
#filter {
    scrollbar-width: none; /* Firefox 64 */
    -ms-overflow-style: none; /* Internet Explorer 11 */
}
#filter::-webkit-scrollbar {
    /** WebKit */
    display: none;
}
</style>
